export default {
  en: {
    'staff_member': 'staff member',
    'staff_members': 'staff members',
    'sack': 'sack',
    'type': 'type',
    'name': 'name',
    'market_value': 'market value',
    'skill': 'skill',
    'patience': 'patience',
    'greediness': 'greediness',
    'resentfulness': 'resentfulness',
    'limit_reached': 'limit of {limit} reached',
    'select_staff_members': 'select staff members',
    'close_deal': 'close deal',
    'team_staff': 'team staff',
    'transfer_market': 'transfer market',
    'sure_you_want_to_sack_the_staff_member?': 'Sure you want to sack the staff member?',
    'this_action_is_permanent_and_can_be_reverted': 'This action is permanent and can be reverted!',
    'sack_x_staff_members': 'sack {count} staff members',
    'sack_staff_members': 'sack staff members',
    'sack_staff_members_for_free_will_cost_negotiations_action_points': 'It is free but will cost negotiations action points.',
    'staff_member_wages': 'staff member wages',
    'x_staff_members_end_their_careers': '{x} staff members of your team end their careers today.',
    '': '',
  }
};
